import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('playback-rate');
export const PlaybackRates = ({ audioRate, setAudioRate }) => {
    const setPlaybackRate = (rate) => () => {
        setAudioRate(rate);
    };

    return <div className={el('container')}>
        <div className={block({active: audioRate === 1}, 'x1')} onClick={setPlaybackRate(1)}>
            <Text>x</Text><Text>1</Text>
        </div>
        <div className={block({active: audioRate === 1.5}, 'x1_5')} onClick={setPlaybackRate(1.5)}>
            <Text>x</Text><Text>1.5</Text>
        </div>
        <div className={block({active: audioRate === 2}, 'x2')} onClick={setPlaybackRate(2)}>
            <Text>x</Text><Text>2</Text>
        </div>
    </div>
}
